// extracted by mini-css-extract-plugin
export default {"fullWidth":"Mo-z","image":"No-z","lazyLoadPicture":"Oo-z","lazyLoadSpinner":"Po-z","lazyLoadSpin":"Qo-z","lazyLoadImage":"Ro-z","hasStyledAspectRatio":"So-z"};